module.exports = __webpack_public_path__ + "08ef048e88af049492e5eb65ff703c74.woff";